import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  on: {
    color: theme.palette.success.main,
  },
  lowVoltage: {
    color: theme.palette.warning.main,
  },
  off: {
    color: theme.palette.error.main,
  },
}));
